import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import Header from "@/components/header/Header";
import ButtonContainer from "@/components/button-container";
import OptionsGroup from "@/components/option-group/OptionsGroup";
import NeedHelpButton from "@/components/need-help-button/need-help-button";

import { useApiResponseHandler } from "@/hooks/useApiResponseHandler";

import { tryCatch } from "@/utils/try-catch";

import { LoyaltyCardAssociationResponse } from "@/models/site-credentials/loyaltycard/LoyaltyCardAssociationResponse";
import { cardAssociationService } from "@/services/site-credentials/mobile/CardAssociationService";
import ErrorMessage from "@/components/error-message/error-message";

export default function LoyaltyCardOtpOptions() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { handleResponse } = useApiResponseHandler();
  const location = useLocation<LoyaltyCardAssociationResponse>();

  const loyaltyCardOtpOptions = location.state.properties.loyaltyCardOtpOptions || [];
  const options = loyaltyCardOtpOptions.map((o) => ({
    type: o.type,
    text: o.contact,
    value: o.type.toString(),
  }))

  const handleOudatedLinkOnClick = async () => {
    setLoading(true);

    const { data: response, error } = await tryCatch(cardAssociationService.outdatedData(
      "/api/site-credentials/loyalty/cards/outdated-data"
    ));

    handleResponse(response, {
      setError
    }, error);

    setLoading(false);
  };

  const handleOnSelect = async (option: string) => {
    setLoading(true);

    const { data: response, error } = await tryCatch(cardAssociationService.sendOtp(
      option,
      location.state != null ? location.state.nextStep : ""
    ));

    handleResponse(response, {
      setError
    }, error);

    setLoading(false);
  };

  return (
    <div className="flex flex-col justify-self-center items-center gap-10 pb-2 w-full">
      <Header
        title={t("card_association_otp_options.header_title")}
        subtitle={t("card_association_otp_options.header_message")}
        showLoading={loading}
        subTitleAriaHidden={false}
        subTitleAriaLabel={t("card_association_otp_options.header_message")}
        previousStepBackXTimes={1}
      />
      <div aria-label={t("card_association_otp_options.header_message")}>
        <OptionsGroup
          options={options}
          disabled={loading}
          onSelect={handleOnSelect}
        />
      </div>
      <ErrorMessage errorString={error} />
      <ButtonContainer>
        <Button
          variant="secondary"
          onClick={handleOudatedLinkOnClick}
          disabled={loading}
        >
          {t("card_association_otp_options.information_outdated")}
        </Button>
        <NeedHelpButton />
      </ButtonContainer>
    </div>
  );
}
